export default __webpack_public_path__ + "static/media/beegame.fa3094b6.png";